import { Grid, Toolbar } from '@mui/material';
import React from 'react';

import { DesktopSidebarToggle } from 'src/features/sidebar/DesktopSidebarToggle';
import { useShell } from 'src/legacy/components/Layout/AppShell/ShellContext';

import NavbarContent, { NavbarContentProps } from './NavbarContent';

const Navbar: React.FC<NavbarContentProps> = ({
  title,
  userLoaded,
  userLoading,
  isClient,
  onOpenSidebarMobile,
  showSearchbar,
  BreadCrumbComponent,
  showBreadCrumb,
  showNavbarAuthActions,
  headerContent,
  ignoreHeaderPadding,
}) => {
  const { isResizableSidebarActive } = useShell();

  const toolbarClass = ignoreHeaderPadding
    ? isResizableSidebarActive
      ? 'gap-2 px-0'
      : 'px-0'
    : isResizableSidebarActive
      ? 'gap-2 px-4 sm:px-9'
      : 'px-4 sm:px-9';

  return (
    <Toolbar className={toolbarClass}>
      <DesktopSidebarToggle />
      <Grid container>
        {headerContent || (
          <NavbarContent
            title={title}
            userLoaded={userLoaded}
            userLoading={userLoading}
            isClient={isClient}
            onOpenSidebarMobile={onOpenSidebarMobile}
            showSearchbar={showSearchbar}
            BreadCrumbComponent={BreadCrumbComponent}
            showBreadCrumb={showBreadCrumb}
            showNavbarAuthActions={showNavbarAuthActions}
          />
        )}
      </Grid>
    </Toolbar>
  );
};

export default Navbar;
